import httpClient from "@/plugins/axios";

export const getFeed = async () => {
    const response = await httpClient.get(`/v2/feed/`);
    return response;
}
